/**
 * Component: SecurePeriodSwitcher
 */

export default class SecurePeriodSwitcher {
    constructor() {
        this.selectors = {
            root: '[data-secure-cards]',
            planInput: '[data-secure-plan-input]'
        };

        this.$rootElement = $(this.selectors.root);
        this.$planInput = this.$rootElement.find(this.selectors.planInput);
        this.init();
    }

    init() {
        if (this.$planInput.length) {
            this.$planInput.on('change', (e) => this.setActivePlanState(e.currentTarget));
        }
    }

    setActivePlanState(input) {
        $('[data-secure-plan]').each((index, element) => {
            $(element).removeClass('selected');
        });

        if (input.checked) {
            $('[data-secure-plan=annual]').addClass('selected');

            $('[data-secure-plan-price]').each((index, element) => {
                if (element.getAttribute('data-secure-plan-price') === 'annual') {
                    element.style.display = 'flex';
                } else {
                    element.style.display = 'none';
                }
            });
        } else {
            $('[data-secure-plan=monthly]').addClass('selected');

            $('[data-secure-plan-price]').each((index, element) => {
                if (element.getAttribute('data-secure-plan-price') === 'monthly') {
                    element.style.display = 'flex';
                } else {
                    element.style.display = 'none';
                }
            });
        }
    }
}
